import { render, staticRenderFns } from "./BlogCarouselWidget.vue?vue&type=template&id=11e458ea"
import script from "./BlogCarouselWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogCarouselWidget.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports